const userStatus = {
    active: 'Active',
    inactive: 'Inactive',
}

export default userStatus